module.exports = __webpack_public_path__ + "static/pressherald-8403d6f25c6d3644a6cba787ace8ff51.png";